import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Alert,
  Link,
} from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { loginWithEmail, signupWithEmail } from '../../services/authService';
import { useNavigate } from 'react-router-dom';

const LoginForm: React.FC = () => {
  const [isSignup, setIsSignup] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { loading, error } = useAppSelector((state) => state.auth);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (isSignup && password !== confirmPassword) {
      return;
    }

    try {
      if (isSignup) {
        await signupWithEmail(email, password, dispatch);
      } else {
        await loginWithEmail(email, password, dispatch);
      }
      navigate('/');
    } catch (err) {
      // Error is handled in the service
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      
      <TextField
        fullWidth
        label="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        margin="normal"
        autoComplete="email"
      />
      
      <TextField
        fullWidth
        label="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        margin="normal"
        autoComplete={isSignup ? 'new-password' : 'current-password'}
      />
      
      {isSignup && (
        <TextField
          fullWidth
          label="Confirm Password"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          margin="normal"
          autoComplete="new-password"
          error={password !== confirmPassword && confirmPassword !== ''}
          helperText={
            password !== confirmPassword && confirmPassword !== ''
              ? 'Passwords do not match'
              : ''
          }
        />
      )}
      
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
        disabled={loading}
      >
        {isSignup ? 'Sign Up' : 'Sign In'}
      </Button>
      
      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <Link
          component="button"
          type="button"
          variant="body2"
          onClick={() => setIsSignup(!isSignup)}
          sx={{ cursor: 'pointer' }}
        >
          {isSignup
            ? 'Already have an account? Sign in'
            : "Don't have an account? Sign up"}
        </Link>
      </Box>
    </Box>
  );
};

export default LoginForm;

